import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { VendorEnquiryCRUD } from '../services/vendorEnquiryService';

const useVendorEnquiryCRUD = (callMessage) => {
  const processIndent = useCallback(
    async (selectedMode, editPurchaseIndentID, requestBody) => {
      try {
        const apiEndpoint = API_ENDPOINTS.VENDOR_ENQUIRY_CRUD_PROCESS;

        const successMessage =
          selectedMode === 0
            ? editPurchaseIndentID !== 0
              ? 'Vendor Enquiry updated Successfully'
              : 'New Vendor Enquiry Created Successfully'
            : 'New Vendor Enquiry Created Successfully';

        const data = await VendorEnquiryCRUD(apiEndpoint, requestBody);

        if (data?.length > 0) {
          callMessage('info', successMessage, 'info');
          return true; // ✅ SUCCESS
        } else {
          callMessage('error', 'No data received from API', 'Error');
          return false;
        }
      } catch (error) {
        callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        return false;
      }
    },
    [callMessage]
  );

  return { processIndent };
};

export default useVendorEnquiryCRUD;


// const useVendorEnquiryCRUD = (callMessage) => {
//     const processIndent = useCallback(async (selectedMode, editPurchaseIndentID, requestBody) => {
//         try {
//             const apiEndpoint = API_ENDPOINTS.VENDOR_ENQUIRY_CRUD_PROCESS;

//             const successMessage = selectedMode === 0
//                 ? (editPurchaseIndentID !== 0 
//                     ? 'Vednor Enquiry updated Successfully' 
//                     : 'New Vednor Enquiry Created Successfully')
//                 : 'New Vednor Enquiry Created Successfully';

//             // Await the API response
//             const data = await VendorEnquiryCRUD(apiEndpoint, requestBody);
            
//             if (data?.length > 0) {
//                 callMessage('info', successMessage, 'info');
//             } else {
//                 callMessage('error', 'No data received from API', 'Error');
//             }
//         } catch (error) {
//             callMessage('error', error.message || 'An unexpected error occurred', 'Error');
//         }
//     }, [callMessage]);

//     return { processIndent };
// };

// export default useVendorEnquiryCRUD;

